module.exports = __webpack_public_path__ + "static/media/mortgageCollab.e48b6861.png";